module.exports = fox._r("fonts/activity.ttf", __webpack_public_path__ + "_/_/_/root/fonts/1ARjj2i.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/activity.ttf
// module id = 408
// module chunks = 4